module.exports = __webpack_public_path__ + "static/media/ikke-karbonneutral-klimapartner.57c255f8.png";